(function() {
	'use strict';
	angular.module('app.setup')
		.controller('valueStreamForm', valueStreamForm);

	valueStreamForm.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'valueStreamService', 'storeService'];
	function valueStreamForm($scope, $rootScope, $timeout, $filter, valueStreamService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.valueStream = {};
		vm.users = [];
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			getUsers();
		}

		function getUsers() {
			valueStreamService.getUsers(undefined, adminConfig.factory.id).then(function(users){
				var data = [];
				if (users !== '') {
					data = users;
				}
				vm.users = data;
			});
		}

		function save() {
			valueStreamService.addValueStream(vm.valueStream, adminConfig.factory.id).then(function(message) {
				$scope.result(message, message == 'Value stream created successfully');
			});
		}

		function close() {
			$scope.result('', false);
		}
	}
})();
